<footer class="footer-area footer-bg2 pt-100">
    <div class="container">
        <div class="footer-midal pb-70">
            <div class="row">
                <div class="col-lg-4 col-sm-7">
                    <div class="footer-widget">
                        <div >
                            <img src="assets/img/logo/logo-yeoha.png" alt="Images" style="width: 210px;">
                        </div>
                        <p>Oyun, uygulama ve yazılım geliştirme alanlarında yenilikçi çözümler sunuyoruz. Dijital dünyada fark yaratmak için buradayız.</p>
                        <!-- <div class="footer-social-icon">
                            <ul class="social-link">
                                <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li> 
                                <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li> 
                                <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li> 
                                <li><a href="#" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li> 
                                <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li> 
                            </ul>
                        </div> -->
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-sm-5">
                    <div class="footer-widget">
                        <h3>Resources</h3>

                        <ul class="footer-list">
                            <li><a routerLink="/">Our Scientists</a></li>
                            <li><a routerLink="/">Our Services</a></li>
                            <li><a routerLink="/">Testimonials</a></li>
                            <li><a routerLink="/">SaaS Solutions</a></li>
                            <li><a routerLink="/">eCommerce</a></li>
                        </ul>
                    </div>
                </div> -->

                <div class="col-lg-4 col-sm-7">
                    <div class="footer-widget pl-5">
                        <h3>Hızlı Linkler</h3>

                        <ul class="footer-list">
                            <li><a routerLink="/">Ana Sayfa</a></li>
                            <li><a routerLink="/about">Hakkımızda</a></li>
                            <!-- <li><a routerLink="/faq">SSS</a></li> -->
                            <!-- <li><a routerLink="/blog">Our Blog</a></li> -->
                            <li><a routerLink="/contact">İletişim</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-5">
                    <div class="footer-widget">
                        <h3>İletişim</h3>

                        <ul class="footer-list-two">
                            <li><i class='flaticon-telephone'></i><a href="tel:+905468643319">+90 546 864 3319</a></li>
                            <li><i class='flaticon-email-1'></i><a href="mailto:yeohagamestudio@gmail.com">yeohagamestudio@gmail.com</a></li>
                            <li><i class='flaticon-place'></i>Kalaba Mahallesi, Keçiören/ Ankara</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copy-right-area">
            <div class="row">
                <div class="col-lg-8">
                    <div class="copy-right-text text-start">
                        <p>© Provide by YEOHA Game Studio</p>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="copy-right-list">
                        <ul>
                            <li><a routerLink="/privacy-policy"> Gizlilik Politikası</a></li>
                            <li><a routerLink="/terms-conditions"> Şartlar ve Koşullar</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>